export default class RefreshTokenError extends Error {
};
